import LoginService from "@/services/LoginService";
import ApiService from "@/services/ApiService";
import RegistrationService from "@/services/RegistrationService";

class UtilityService {
  showDefaultError(error) {
    const vm = window.vm;

    const errorTrace =
      error &&
      error.response &&
      error.response.data &&
      error.response.data.trace
        ? error.response.data.trace
        : null;

    const tnbTrace =
      error &&
      error.response &&
      error.response.headers &&
      error.response.headers["tnb-trace"]
        ? error.response.headers["tnb-trace"]
        : null;

    vm.$root.$emit("openModal", "genericModal", {
      trace: errorTrace || tnbTrace,
      title: (error && error.title) || "Attenzione",
      message: "Si è verificato un errore. Per maggiori informazioni contattaci"
    });
  }

  showErrorModal(errorMsg, title) {
    const vm = window.vm;
    vm.$root.$emit("openModal", "genericModal", {
      title: title || "Attenzione",
      message:
        errorMsg ||
        "Si è verificato un errore. Per maggiori informazioni contattaci"
    });
  }
  showSuccessModal(successMsg, title) {
    const vm = window.vm;
    vm.$root.$emit("openModal", "genericModal", {
      title: title || "Ok",
      message: successMsg || "Operazione conclusa con successo"
    });
  }

  cleanAll() {
    LoginService.removeAccessToken();
    LoginService.removeRefreshToken();
    LoginService.removeFromApp();
    RegistrationService.removeCurrentRegistrationId();
    RegistrationService.removeIsTutor();
    sessionStorage.removeItem("cr_details");
    sessionStorage.removeItem("cr_me");
    sessionStorage.removeItem("cr_wi");
    sessionStorage.removeItem("cr_upgrade_physical");
  }

  sendPostMessage(obj) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(obj));
    }
  }

  openUrl(url) {
    if (LoginService.getFromApp() === true) {
      this.sendPostMessage({ action: "openUrl", url });
    } else {
      var docPage = window.open(url, "_blank");
      docPage.opener = null;
    }
  }

  goToFeePot() {
    const fromApp = LoginService.getFromApp();

    //APP redirect
    if (fromApp) {
      this.cleanAll();
      this.sendPostMessage({
        action: "feePot"
      });
    } else {
      let url = process.env.VUE_APP_DASHBOARD_URL;
      this.cleanAll();
      window.location.replace(url);
    }
  }

  goToWalletRecharge() {
    const fromApp = LoginService.getFromApp();

    //APP redirect
    if (fromApp) {
      this.cleanAll();
      this.sendPostMessage({
        action: "walletRecharge"
      });
    } else {
      let url = process.env.VUE_APP_DASHBOARD_URL;
      this.cleanAll();
      window.location.replace(url);
    }
  }

  goToProfileActivation(cardId) {
    const fromApp = LoginService.getFromApp();

    //APP redirect
    if (fromApp) {
      this.cleanAll();
      this.sendPostMessage({
        action: "activateProfile",
        cardId
      });
    } else {
      //WEB redirect
      let url = process.env.VUE_APP_DASHBOARD_URL;
      this.cleanAll();
      window.location.replace(url);
    }
  }

  p2pToMinor(data) {
    const fromApp = LoginService.getFromApp();

    //APP redirect
    if (fromApp) {
      this.cleanAll();
      this.sendPostMessage({
        action: "sendP2PToMinor",
        data
      });
    } else {
      //WEB redirect
      let url = process.env.VUE_APP_DASHBOARD_URL;
      this.cleanAll();
      window.location.replace(url);
    }
  }

  backToInitialView() {
    const fromApp = LoginService.getFromApp();

    //APP redirect
    if (fromApp) {
      let actionType = "backToBank";
      this.cleanAll();
      this.sendPostMessage({
        action: "userAction",
        type: actionType
      });
    } else {
      //WEB redirect

      let url = process.env.VUE_APP_DASHBOARD_URL;
      this.cleanAll();
      window.location.replace(url);
    }
  }

  sanitize(str, skipApostrophe = false) {
    if (!str) return "";
    let r = str;
    r = r.replace(new RegExp(/[àáâãäå]/g), `a${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[ÀÁÂÃÄÅ]/g), `A${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[èéêë]/g), `e${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[ÈÉÊË]/g), `E${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[ìíîï]/g), `i${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[ÌÍÎÏ]/g), `I${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[òóôõö]/g), `o${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[ÒÓÔÕÖ]/g), `O${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[ùúûü]/g), `u${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/[ÙÚÛÜ]/g), `U${skipApostrophe ? "" : "'"}`);
    r = r.replace(new RegExp(/æ/g), "ae");
    r = r.replace(new RegExp(/Æ/g), "AE");
    r = r.replace(new RegExp(/ç/g), "c");
    r = r.replace(new RegExp(/Ç/g), "C");
    r = r.replace(new RegExp(/ñ/g), "n");
    r = r.replace(new RegExp(/Ñ/g), "N");
    r = r.replace(new RegExp(/œ/g), "oe");
    r = r.replace(new RegExp(/Œ/g), "OE");
    r = r.replace(new RegExp(/[ýÿ]/g), "y");
    r = r.replace(new RegExp(/[ÝŸ]/g), "Y");
    return r;
  }

  sort(list, orderBy) {
    return list && list.length > 0
      ? list.sort((a, b) => a[orderBy].localeCompare(b[orderBy]))
      : [];
  }

  sanitizeAddressString(address) {
    let r = this.sanitize(address);
    return r.toUpperCase();
  }

  scrollTopPage() {
    setTimeout(() => {
      const $pageElement = document.querySelector(".page");
      $pageElement.scrollTop = $pageElement.scrollHeight;
    }, 100);
  }

  isDesktopOrAndroid() {
    const d = window.vm.$store.state.detect;
    return (d?.platform?.type === "desktop" || d?.os?.name === "Android");
  }

  cachedService(data) {
    return new Promise(function(resolve, reject) {
      if (!data || !data.storageKey || !data.service) {
        reject(
          "ERROR: a cached service should have two properties 'key' and 'service'"
        );
        return;
      }
      const cachedResponse = sessionStorage.getItem(data.storageKey);
      if (cachedResponse) {
        resolve(JSON.parse(cachedResponse));
        return;
      }

      const m = data.method || "get";
      return ApiService[m](data.service, data.params).then(
        response => {
          if (response) {
            const d = data.getNode ? data.getNode(response) : response;
            sessionStorage.setItem(data.storageKey, JSON.stringify(d ? d : []));
            resolve(d);
          } else {
            reject();
          }
        },
        () => {
          reject();
        }
      );
    });
  }

  debounce(func, wait = 500, immediate) {
    var timeout;

    return function executedFunction() {
      var context = this;
      var args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(later, wait);

      if (callNow) func.apply(context, args);
    };
  }

  EventTrackingHandler(currentRoute) {
    const appsflyerEvent =
      currentRoute && currentRoute.meta && currentRoute.meta.appsflyer_event
        ? currentRoute.meta.appsflyer_event
        : null;

    if (appsflyerEvent) {
      const eventName =
        process && process.env && process.env.NODE_ENV === "production"
          ? appsflyerEvent
          : `TEST_${appsflyerEvent}`;

      const step = eventName.split("step").pop();

      this.AppsflyerTracking(eventName);
      this.GATracking(step);
    }
  }

  getTrackingsAdditionalData() {
    const vm = window.vm;

    const eventValues = {
      minor:
        RegistrationService.getCurrentFlow() === "PREPAID_CARD_MINOR"
          ? true
          : null,
      orderID:
        RegistrationService.getCurrentRegistrationId() !== "me"
          ? RegistrationService.getCurrentRegistrationId()
          : null,
      deviceType: vm.$store.state.detect.platform
        ? vm.$store.state.detect.platform.vendor
        : null,

      gender: vm.$store.state.user.gender,
      cardId: vm.$store.state?.registrations?.prepaidCardResource?.id || null
    };

    //remove empty values from ob
    Object.keys(eventValues).forEach(
      key =>
        (eventValues[key] == null || eventValues[key] == undefined) &&
        delete eventValues[key]
    );

    return eventValues;
  }

  AppsflyerTracking(eventName) {
    const eventValues = this.getTrackingsAdditionalData();

    console.log("APPSFLYER EVENT: " + eventName, eventValues);
    if (!LoginService.getFromApp()) {
      return;
    }

    this.sendPostMessage({
      action: "SendAppflyerEvent",
      data: {
        eventName,
        eventValues
      }
    });
  }

  GATracking(step, eventName) {
    const eventValues = this.getTrackingsAdditionalData();
    eventValues.deviceType = LoginService.getFromApp() ? "App" : "Web";
    let gaEvent =
      process && process.env && process.env.NODE_ENV === "production"
        ? "richiesta_carta"
        : "TEST_richiesta_carta";

    const ga = {
      event: eventName || gaEvent,
      funnelStep: `Step ${step}`,
      ...eventValues
    };
    console.log("GA EVENT: ", ga);
    if (window.dataLayer) {
      window.dataLayer.push(ga);
    } else {
      console.warn("Warning! GA Event not sent");
    }
  }
}

export default new UtilityService();
